import { render, staticRenderFns } from "./activityNotice.vue?vue&type=template&id=466015a9&scoped=true&"
import script from "./activityNotice.vue?vue&type=script&lang=js&"
export * from "./activityNotice.vue?vue&type=script&lang=js&"
import style0 from "./activityNotice.vue?vue&type=style&index=0&id=466015a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466015a9",
  null
  
)

export default component.exports